import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription, take } from 'rxjs';
import { TrnQualificationUserHistorySearchDto } from 'src/models/ts/trn-qualification-user-history-search-dto.model';
import { QualificationHistoryDto } from 'src/models/ts/trn-qualification-user-history-dto.model';
import { QualificationMediaDto } from 'src/models/ts/qualification-media-dto.model';
import { DocumentTemplateDto } from 'src/models/ts/document-template-dto.model';
import { DocumentDataModel } from 'src/models/ts/document-data-model.model';
import { DownloadService } from 'src/app/core/services/download/download.service';
import { TrnUserQualificationDto } from 'src/models/ts/trn-user-qualification-dto.model';
import { TimeRangeUnitType } from 'src/models/ts/time-range-unit-type.model';
import { CollectionFormService } from 'src/app/features/bizzmine/form/services/collection-form.service';

@Injectable({
  providedIn: 'root'
})
export class QualificationSkillMatrixApiService {

  public constructor(private http: HttpClient, private downloadService: DownloadService) {
  }

  //TODO: When filter exists remove partial
  // /api/trainingapp/{trnappsID:long}/qualification/{qualificationsID:long}/user/{usersID:long}
  public getQualificationHistoryForUser(trnQualificationUserHistorySearchDto: TrnQualificationUserHistorySearchDto): Observable<QualificationHistoryDto[]> {
    return this.http.get<QualificationHistoryDto[]>(`api/trainingapp/${trnQualificationUserHistorySearchDto.TrnAppID}/qualification/${trnQualificationUserHistorySearchDto.QualificationsID}/user/${trnQualificationUserHistorySearchDto.UserID}`);
  }

  /**
   * Sets a qualification exception for a user
   * @param trnAppsId The training application ID
   * @param qualificationsId The qualification ID
   * @param userId The user ID
   * @param required Whether the qualification is required
   * @param request The qualification exception request containing comments and event type
   * @returns An Observable of the HTTP response
   */
  public setQualificationException(data: any): Observable<any> {
    return this.http.post(
      `api/trainingapp/${data.TrnAppID}/qualification/${data.QualificationsID}/user/${data.UserID}`,
      data.Request
    );
  }

  public submitManualQualification(trnappsId: number, qualificationDto: Partial<TrnUserQualificationDto>): Observable<any> {
    qualificationDto = structuredClone(qualificationDto);
    qualificationDto.QualificationAchievedOn = CollectionFormService.convertDateTimeToDate(qualificationDto.QualificationAchievedOn as Date);
    return this.http.post<void>(`api/trainingapp/${trnappsId}/manualqualification`, qualificationDto);
  }


  public getExpiryDate(request: {
    TimeRange: {
      UnitType: TimeRangeUnitType
      Value: number
    },
    StartDate: Date | undefined,
  }): Observable<Date> {
    return this.http.post<Date>(`api/trainingapp/getNextExpiryDate`, request);
  }


  public downloadFile(collectionsId: number, fileData: DocumentDataModel): Subscription | undefined {
    return this.http.post(
      `api/collection/${collectionsId}/instance/${fileData.InstancesID}/version/${fileData.VersionsID}/media/${fileData.MediasID}/download`,
      {},
      { responseType: 'arraybuffer' })
      .pipe(take(1))
      .subscribe((data: ArrayBuffer) => {
        this.downloadService.startDownload(data, fileData.Filename);
      });
  }


  /**
   * Posts a certificate media ID for a training application
   * @param trnappsID - The ID of the training application
   * @param media - The qualification media data
   * @returns An Observable of the API response
   */
  public postCertificateMediaId(trnappsId: number, media: QualificationMediaDto): Observable<void> {
    const url = `api/trainingapp/${trnappsId}/certificate`;
    return this.http.post<void>(url, media);
  }

  /**
   * Gets certificate template information for a training application
   * @param trnAppsID - The ID of the training application
   * @returns An Observable with the template information
   */
  public getCertificateTemplateInfo(trnAppsId: number): Observable<DocumentTemplateDto> {
    const url = `api/trainingapp/${trnAppsId}/certificatetemplateinfo`;
    return this.http.get<DocumentTemplateDto>(url);
  }

  /**
   * Gets certificate media ID for a training application and user qualification
   * @param trnappsID - The ID of the training application
   * @param userqualificationsID - The ID of the user qualification
   * @returns An Observable with the certificate media ID
   */
  public getCertificateMediaId(intent: {
    trnappsId: number,
    userqualificationsId: number
  }): Observable<DocumentDataModel> {
    const url = `api/trainingapp/${intent.trnappsId}/certificate/${intent.userqualificationsId}`;
    return this.http.get<DocumentDataModel>(url);
  }


}